module.exports = __webpack_public_path__ + "img/hacienda_chiapas-3.9262eda6.png";